// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Y3ps","inputWrap":"Table_inputWrap__9oDL4","col":"Table_col__maDqz","bmiTooltip":"Table_bmiTooltip__2cMLz"};